// utils/formUtils.js

// ✅ Utility to handle nested state updates
export const updateNestedState = (prevState, name, value) => {
  const updatedState = JSON.parse(JSON.stringify(prevState)); // Deep copy
  const keys = name.split(".");
  let nested = updatedState;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      nested[key] = value;
    } else {
      if (!nested[key]) nested[key] = {};
      nested = nested[key];
    }
  });

  return updatedState;
};

export const handleInputChange = (e, setFormData) => {
  const { name, value } = e.target;
  setFormData((prev) => updateNestedState(prev, name, value));
};

// ✅ Utility for file uploads with preview
export const handleFileUpload = (file, setState, fieldName, previewField) => {
  if (!file) return;
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onloadend = () => {
    setState((prev) => ({
      ...prev,
      [fieldName]: file,
      [previewField]: reader.result,
    }));
  };
};

// ✅ Utility for country selection
export const selectCountry = (e, setFormData, setDropdownData, updatedStates, objectType) => {
  if (!e) return;
  if (objectType === "Staff") {
    setFormData((prev) => ({
      ...prev,
      staff: {
        ...prev.staff,
        address: {
          ...prev.staff.address,
          country: e,
          country_key: e.key,
          state: {},
          state_key: "",
          city: {},
          city_key: "",
        },
      },
    }));

    setDropdownData((prev) => ({
      ...prev,
      state_list: updatedStates(e.key),
      city_list: [],
    }));
  }
  if (objectType === "Address") {
    setFormData((prev) => ({
      ...prev,
      address: {
        ...prev.address,
        country: e,
        country_key: e.key,
        state: {},
        state_key: "",
        city: {},
        city_key: "",
      },
    }));

    setDropdownData((prev) => ({
      ...prev,
      state_list: updatedStates(e.key),
      city_list: [],
    }));
  }

};

// ✅ Utility for state selection
export const selectState = (e, setFormData, setDropdownData, updatedCities, objectType) => {
  if (!e) return;

  if (objectType === "Staff") {
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        staff: {
          ...prev.staff,
          address: {
            ...prev.staff.address,
            state: e,
            state_key: e.key,
            city: {},
            city_key: "",
          },
        },
      };

      setDropdownData((prevDropdown) => ({
        ...prevDropdown,
        city_list: updatedCities(updatedFormData.staff.address.country_key, e.key),
      }));

      return updatedFormData;
    });
  } else if (objectType === "Address") {
    setFormData((prev) => {
      const updatedFormData = {
        ...prev,
        address: {
          ...prev.address,
          state: e,
          state_key: e.key,
          city: {},
          city_key: "",
        },
      };

      setDropdownData((prevDropdown) => ({
        ...prevDropdown,
        city_list: updatedCities(updatedFormData.address.country_key, e.key),
      }));

      return updatedFormData;
    });
  }
};

// ✅ Utility for city selection
export const selectCity = (e, setFormData, objectType) => {
  if (!e) return;

  if (objectType === "Staff") {
    setFormData((prev) => ({
      ...prev,
      staff: {
        ...prev.staff,
        address: {
          ...prev.staff.address,
          city: e,
          city_key: e.key,
        },
      },
    }));
  }
  if (objectType === "Address") {
    setFormData((prev) => ({
      ...prev,
      address: {
        ...prev.address,
        city: e,
        city_key: e.key,
      },
    }));
  }

};
